(function(){
  var selector='.visual-category,.trust-item,.hp-products .section-head,.hp-product-card,.spark-mushroom-card,.pet-home-copy,.pet-home-media,.lifestyle-section,.newsletter,.review-card';

  function initSparkMotion(){
    if(!document.body || !document.body.classList.contains('template-index')) return;
    var items=Array.prototype.slice.call(document.querySelectorAll(selector));
    if(!items.length) return;

    items.forEach(function(el,index){
      el.classList.add('spark-motion');
      if(el.matches('.visual-category,.trust-item,.hp-product-card,.spark-mushroom-card,.review-card')){
        el.style.setProperty('--spark-delay',((index%4)*90)+'ms');
      }
    });

    function revealVisible(){
      var vh=window.innerHeight || document.documentElement.clientHeight;
      items.forEach(function(el){
        if(el.classList.contains('spark-in-view')) return;
        var r=el.getBoundingClientRect();
        if(r.top < vh*0.92 && r.bottom > 0) el.classList.add('spark-in-view');
      });
    }

    requestAnimationFrame(function(){requestAnimationFrame(revealVisible)});
    var ticking=false;
    function onMove(){
      if(ticking) return;
      ticking=true;
      requestAnimationFrame(function(){revealVisible();ticking=false});
    }
    window.addEventListener('scroll',onMove,{passive:true});
    window.addEventListener('resize',onMove,{passive:true});
    window.addEventListener('orientationchange',onMove,{passive:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSparkMotion,{once:true});
  else initSparkMotion();
  window.addEventListener('pageshow',initSparkMotion);
  document.addEventListener('shopify:section:load',initSparkMotion);
})();